import React from 'react';

/**
 * Styled wrapper around native <input type="time">.
 * Matches the form input design without overriding the browser time picker.
 */
function CustomTimeInput({ value = '12:00', onChange, disabled = false }) {
  return (
    <input
      type="time"
      value={value}
      onChange={(e) => {
        if (typeof onChange === 'function') onChange(e.target.value);
      }}
      disabled={disabled}
      style={inputStyle}
    />
  );
}

const inputStyle = {
  width: '100%',
  minHeight: '48px',
  borderRadius: '12px',
  border: '1px solid var(--border)',
  background: 'var(--input-bg)',
  color: 'var(--text-primary)',
  padding: '12px 14px',
  fontSize: '14px',
  fontWeight: 600,
  boxSizing: 'border-box',
  outline: 'none',
  colorScheme: 'dark',
};

export default CustomTimeInput;
